var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "problemOrder" } },
    [
      _c(
        "div",
        {
          staticClass: "yto-box search-form",
          staticStyle: { "padding-bottom": "0" },
        },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: true, model: _vm.form, "label-width": "75px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "time-style",
                      attrs: { prop: "createTime", label: "生成时间" },
                    },
                    [
                      _c("yto-date-picker", {
                        attrs: {
                          maxRangeVal: 31,
                          "picker-options": _vm.pickerOptions1,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          type: "datetimerange",
                          "default-time": ["00:00:00", "23:59:59"],
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          clearable: false,
                          editable: false,
                        },
                        model: {
                          value: _vm.form.createTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "createTime", $$v)
                          },
                          expression: "form.createTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "problemCode", label: "问题类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.problemCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "problemCode", $$v)
                            },
                            expression: "form.problemCode",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: "" },
                          }),
                          _vm._l(_vm.problemList, function (item, index) {
                            return _c("el-option", {
                              key: item.problemCode + index,
                              attrs: {
                                label: item.problemName,
                                value: item.problemCode,
                              },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "处理状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.customerStateId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "customerStateId", $$v)
                            },
                            expression: "form.customerStateId",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: "" },
                          }),
                          _c("el-option", {
                            attrs: { label: "未回复", value: "tobe" },
                          }),
                          _c("el-option", {
                            attrs: { label: "已回复", value: "done" },
                          }),
                          _c("el-option", {
                            attrs: { label: "网点已处理", value: "wdgj_done" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户编码", prop: "customerCode" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选择",
                            clearable: "",
                          },
                          on: {
                            change: _vm.handleSelect,
                            clear: _vm.clearCustomerCode,
                          },
                          model: {
                            value: _vm.form.customerCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "customerCode", $$v)
                            },
                            expression: "form.customerCode",
                          },
                        },
                        _vm._l(_vm.restaurants, function (item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: {
                              label: item.code + "-" + item.name,
                              value: item.code,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺名称", prop: "sellerId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "请选择",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.sellerId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "sellerId", $$v)
                            },
                            expression: "form.sellerId",
                          },
                        },
                        _vm._l(_vm.shopList, function (item) {
                          return _c("el-option", {
                            key: item.shopId,
                            attrs: { label: item.shopName, value: item.shopId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "textarea-style",
                      attrs: { label: "运单号", prop: "waybillNo" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          resize: "none",
                          placeholder:
                            "请输入单号，最多200个，请用，或者换行隔开",
                        },
                        model: {
                          value: _vm.form.waybillNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "waybillNo", $$v)
                          },
                          expression: "form.waybillNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticStyle: { float: "right", "margin-right": "0" } },
                    [
                      _c(
                        "div",
                        { staticClass: "button-group" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.pageChange(1)
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "normal-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm("searchForm")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-refresh-left y-fc-4C84FF",
                              }),
                              _vm._v("重置"),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                plain: "",
                                disabled: _vm.total === 0 || _vm.exportLoading,
                              },
                              on: { click: _vm.exportFile },
                            },
                            [_vm._v("导出")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "yto-box" }, [
        _c(
          "div",
          { staticClass: "mb20" },
          [
            _c(
              "el-button",
              {
                staticClass: "mr20 copyBtn",
                attrs: {
                  type: "primary",
                  id: "copy_text",
                  "data-clipboard-text": _vm.copyTxt,
                },
                on: { click: _vm.copyWaybillNo },
              },
              [
                _c("i", { staticClass: "el-icon-document-copy y-mr-5" }),
                _vm._v("复制单号"),
              ]
            ),
            _c(
              "el-tooltip",
              { attrs: { effect: "light", placement: "bottom-start" } },
              [
                _c("span", { attrs: { slot: "content" }, slot: "content" }, [
                  _c("span", { staticStyle: { color: "#330000" } }, [
                    _vm._v("待办须知"),
                  ]),
                  _c("br"),
                  _c("span", { staticStyle: { color: "#666666" } }, [
                    _vm._v(
                      "合作网点推送给您需要确认的快件问题，请及时回复您的处理意见，以便网点尽快为您转出快件"
                    ),
                  ]),
                  _c("br"),
                  _c("span", { staticStyle: { color: "#666666" } }, [
                    _vm._v("未回复：需要您回复的快件问题"),
                  ]),
                  _c("br"),
                  _c("span", { staticStyle: { color: "#666666" } }, [
                    _vm._v(
                      "已回复：您已回复的快件问题（组织内任何成员回复都可见）"
                    ),
                  ]),
                  _c("br"),
                  _c("span", { staticStyle: { color: "#666666" } }, [
                    _vm._v("网点已处理：网点客服已代您处理，无需回复"),
                  ]),
                ]),
                _c("span", { staticClass: "helpInfo" }, [
                  _c("i", {
                    staticClass: "el-icon-warning systemColor helpIcon mr5",
                    staticStyle: { cursor: "pointer" },
                  }),
                  _vm._v("待办须知"),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "yto-table" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.tableLoading,
                    expression: "tableLoading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "waybillNo",
                    label: "运单号",
                    "min-width": "130",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "hilightColor",
                              on: {
                                click: function ($event) {
                                  return _vm.showWaybillDetail(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.waybillNo))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "kcode", label: "客户编码" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.kcode
                            ? _c("span", [_vm._v(_vm._s(scope.row.kcode))])
                            : _vm._e(),
                          scope.row.kcode && scope.row.kname
                            ? _c("span", [_vm._v(" - ")])
                            : _vm._e(),
                          scope.row.kname
                            ? _c("span", [_vm._v(_vm._s(scope.row.kname))])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "sellerName", label: "店铺名称" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "problemName", label: "问题类型" },
                }),
                _c("el-table-column", {
                  staticClass: "desc-form",
                  attrs: { "min-width": "200px", label: "问题内容" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                trigger: "hover",
                                placement: "top",
                                width: "400",
                              },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "hover-popover",
                                  staticStyle: { "font-size": "12px" },
                                },
                                [
                                  scope.row.problemType == "issue"
                                    ? _c("span", [
                                        _vm._v(_vm._s(scope.row.problemDesc)),
                                      ])
                                    : _vm._e(),
                                  scope.row.problemType ==
                                    "complaint_problem" ||
                                  scope.row.problemType == "urge_problem"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.problemContent)
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "line-height": "22px",
                                    "max-height": "66px",
                                    overflow: "hidden",
                                    "text-overflow": "ellipsis",
                                    "white-break": "wrap",
                                  },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  scope.row.problemType == "issue"
                                    ? _c(
                                        "span",
                                        { staticClass: "overflowHiding" },
                                        [_vm._v(_vm._s(scope.row.problemDesc))]
                                      )
                                    : _vm._e(),
                                  scope.row.problemType ==
                                    "complaint_problem" ||
                                  scope.row.problemType == "urge_problem"
                                    ? _c(
                                        "span",
                                        { staticClass: "overflowHiding" },
                                        [
                                          _vm._v(
                                            _vm._s(scope.row.problemContent)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "problemCreateTime",
                    label: "生成时间",
                    "min-width": "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "customerStateId", label: "处理状态" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.customerStateId === "tobe"
                            ? _c("span", [_vm._v("未回复")])
                            : _vm._e(),
                          scope.row.customerStateId === "done"
                            ? _c("span", [_vm._v("已回复")])
                            : _vm._e(),
                          scope.row.customerStateId === "wdgj_done"
                            ? _c("span", [_vm._v("网点已处理")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  staticClass: "desc-form",
                  attrs: {
                    prop: "replyContent",
                    "min-width": "200px",
                    label: "处理内容",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                trigger: "hover",
                                placement: "top",
                                width: "400",
                              },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "hover-popover",
                                  staticStyle: { "font-size": "12px" },
                                },
                                [_vm._v(_vm._s(scope.row.replyContent))]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "line-height": "22px",
                                    "max-height": "66px",
                                    overflow: "hidden",
                                    "text-overflow": "ellipsis",
                                    "white-break": "wrap",
                                  },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "overflowHiding" },
                                    [_vm._v(_vm._s(scope.row.replyContent))]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "customerProcessTime", label: "处理时间" },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "80px" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.customerStateId === "tobe"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleOrder(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("回复")]
                              )
                            : _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleOrder(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.pageNo,
                "page-sizes": [10, 20, 50],
                "page-size": _vm.limit,
                total: _vm.total,
                layout: "total, sizes, prev, pager, next",
              },
              on: {
                "size-change": _vm.limitChange,
                "current-change": _vm.pageChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm.showDialog
        ? _c("orderTrackingDetails", {
            ref: "orderTrackingDetails",
            attrs: {
              value: _vm.showDialog,
              fromPage: "problemOrder",
              data: _vm.orderDetailsData,
            },
            on: { close: _vm.closeDetailInfo },
          })
        : _vm._e(),
      _vm.handleProblemDialog
        ? _c("handleProblemOrder", {
            ref: "handleProblemOrder",
            attrs: {
              value: _vm.handleProblemDialog,
              waybillNo: _vm.handleProbleData.waybillNo,
              problemType: _vm.handleProbleData.problemType,
              id: _vm.handleProbleData.id,
            },
            on: { close: _vm.closehandleProblem },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "imgDialog",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.dialogUrlType == "image" ? "图片" : "视频",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closeImg,
          },
        },
        [
          _vm.dialogVisible
            ? _c("div", [
                _vm.dialogUrlType == "image"
                  ? _c("img", {
                      staticStyle: {
                        width: "auto",
                        "max-width": "100%",
                        "max-height": "550px",
                        display: "block",
                        margin: "0 auto",
                      },
                      attrs: { src: _vm.dialogImageUrl, alt: "" },
                    })
                  : _c(
                      "video",
                      {
                        staticStyle: {
                          width: "100%",
                          height: "550px",
                          display: "block",
                          margin: "0 auto",
                        },
                        attrs: { controls: "", name: "media" },
                      },
                      [
                        _c("source", {
                          attrs: { src: _vm.dialogImageUrl, type: "video/mp4" },
                        }),
                      ]
                    ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }